import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumbs } from "../../components/core/Breadcrumbs";
import { EditReconciliationForm } from "../../features/reconciliation/components/EditReconciliationForm";
import { AuthenticatedLayout } from "../../features/user/layouts/AuthendicatedLayout";

export const EditReconciliation = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, [id, navigate]);

  return (
    <AuthenticatedLayout>
      <Breadcrumbs />
      <EditReconciliationForm id={id} />
    </AuthenticatedLayout>
  );
};
